/**
 * The two main categories that get a form of their own. A "segment" is which form
 * to show, not which category the product is saved under — several main
 * categories can share the livestock form.
 */
export const LIVESTOCK_SEGMENT = 1;
export const TANK_SEGMENT = 5;
export const OTHER_SEGMENT = 0;

/**
 * Is this main category livestock?
 *
 * Matched on the NAME, not the id, because there is more than one livestock
 * category and their ids differ per database — "Marine Livestock" is 240 in
 * production and 238 in UAT. Naming is the one thing that is stable across
 * environments, and it keeps working when "Livestock" is renamed to
 * "Freshwater Livestock".
 */
export const isLivestockCategoryName = (name: string | undefined | null): boolean =>
  /livestock/i.test(name ?? "");

/**
 * Which form a category should use. Falls back to the id when no name is
 * available — callers that only hold an id still resolve the original Livestock
 * (1) and Tank (5) correctly.
 */
/** The categories endpoint returns both `category_name` and a `name` alias. */
export interface CategoryLike {
  id: number;
  category_name?: string;
  name?: string;
}

export const categoryNameOf = (c: CategoryLike | undefined): string | undefined =>
  c?.category_name ?? c?.name;

export const getSegmentForCategory = (categoryId: number, categories?: CategoryLike[]): number => {
  const name = categoryNameOf(categories?.find((c) => c.id === categoryId));
  if (name !== undefined) {
    if (isLivestockCategoryName(name)) return LIVESTOCK_SEGMENT;
    return categoryId === TANK_SEGMENT ? TANK_SEGMENT : OTHER_SEGMENT;
  }
  if (categoryId === LIVESTOCK_SEGMENT) return LIVESTOCK_SEGMENT;
  if (categoryId === TANK_SEGMENT) return TANK_SEGMENT;
  return OTHER_SEGMENT;
};
